import { render, staticRenderFns } from "./ModalNewCase.vue?vue&type=template&id=32836f63&lang=pug&"
import script from "./ModalNewCase.vue?vue&type=script&lang=js&"
export * from "./ModalNewCase.vue?vue&type=script&lang=js&"
import style0 from "./ModalNewCase.vue?vue&type=style&index=0&id=32836f63&prod&lang=sass&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports